module.exports = __webpack_public_path__ + "static/img/con-2.62d6e39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/con-2.png
// module id = M/Wd
// module chunks = 1